module.exports = __webpack_public_path__ + "static/media/Sharp-LQ190E1LX76-Mechanical-Drawing-clean.f4a538c4.png";